import React from 'react';
import PropTypes from 'prop-types';
import NotificationModal from 'base/components/NotificationModal';
import PrimaryCta from 'base/components/PrimaryCta';

class MenuHoursExpiredNotification extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func,
    handlePrimaryCta: PropTypes.func
  };

  render() {
    return (
      <NotificationModal
        title="Oops! This menu has changed"
        body="You can select a new time for pickup. Please note item availability might have changed."
        onClose={this.props.closeModal}
      >
        <PrimaryCta
          label="Set A New Time"
          handleClick={this.props.handlePrimaryCta}
          fullWidth
        />
      </NotificationModal>
    );
  }
}

export default MenuHoursExpiredNotification;
